module.exports = __webpack_public_path__ + "img/827C87_4F3937_605457_534C4E-256px.d59d9c99.png";